<mx-object-form
        [ngClass]="this.hasError() ? 'hide-form' : ''" (customize)='onCustomize($event)'>
</mx-object-form>
<div class="error-message" [ngClass]="this.hasError() ? '' : 'hidden'">
    <mat-icon>warning</mat-icon>
    <prl-label [value]="getErrorLabel()"/>
</div>
<div class="buttons">
    <mx-button [ngClass]="this.hasError() ? '' : 'hidden'" [buttonModel]="cancelButton"></mx-button>
</div>
